import { useCallback, useMemo, useState } from "react";
import { SnackbarContext } from "./SnackbarContext.ts";

export const useSnackbarState = () => {
  const [snackbar, setSnackbar] = useState<{
    id: number;
    open: boolean;
    message: string;
    severity: "success" | "error";
  }>({
    id: 0,
    open: false,
    message: "",
    severity: "success",
  });

  const snackbarContext = useMemo(
    (): SnackbarContext => ({
      displayError: (message) =>
        setSnackbar((prev) => ({
          id: prev.id + 1,
          open: true,
          message,
          severity: "error",
        })),
      displaySuccess: (message) =>
        setSnackbar((prev) => ({
          id: prev.id + 1,
          open: true,
          message,
          severity: "success",
        })),
    }),
    [],
  );

  const closeSnackbar = useCallback(
    () => setSnackbar((prevState) => ({ ...prevState, open: false })),
    [],
  );

  return { snackbar, closeSnackbar, snackbarContext };
};
